/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_SubtitleInputs */

const en_fc_vs_subtitle = /** @type {(inputs: Fc_Vs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same familiar workflow. Very different price, philosophy and maturity. Here is what actually differs.`)
};

/**
* | output |
* | --- |
* | "Same familiar workflow. Very different price, philosophy and maturity. Here is what actually differs." |
*
* @param {Fc_Vs_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_subtitle = /** @type {((inputs?: Fc_Vs_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_subtitle(inputs)
});
export { fc_vs_subtitle as "fc.vs.subtitle" }